export default () => ({
  root: {
    textAlign: 'center',
  },
});
